import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../common/Translate';
import { useGuaranteedPrice } from '../../../hooks/useGuaranteedPrice/useGuaranteedPrice';
import { currencySign } from '../../../Utils/currencySign';

const CounterAppraisalWhenPriceModified = ({ recordId }) => {
  const { guaranteedPrice, getValuationDataByStatus } = useGuaranteedPrice(recordId);
  const { price } = getValuationDataByStatus();
  return (
    <div>
      <div className="m-2 mb-4">
        <span>{t('sorryInformationMaintainPrice')}</span>
      </div>
      <div className="m-2">
        <div>
          <span className="font-weight-bold">{t('initialInspection')} : </span>
          <span>{currencySign(price)}</span>
        </div>
        <div>
          <span className="font-weight-bold">{t('counterAppraisalNrm')} : </span>
          <span className="status-label-red">{currencySign(guaranteedPrice?.guaranteeablePriceCounter)}</span>
        </div>
        {price !== guaranteedPrice?.guaranteeablePriceCounter && (
          <div className="mt-2">
            <span className="font-weight-bold">{t('totalGapBetweenInspection')} : </span>
            <span className="status-label-red">{currencySign(price - guaranteedPrice?.guaranteeablePriceCounter)}</span>
          </div>
        )}
      </div>

      <div className="m-2">
        <div>
          <span>{t('gapInTheDeliveryDate')} : </span>
          <span>{currencySign(guaranteedPrice.gapDeliveryDate)}</span>
        </div>
        <div>
          <span>{t('gapOnTheReconditioningCosts')} : </span>
          <span>{currencySign(guaranteedPrice.gapReconditionningCost)}</span>
        </div>
        <div>
          <span>{t('gapOnTheMileage')} : </span>
          <span>{currencySign(guaranteedPrice.gapMileage)}</span>
        </div>
        <div>
          <span>{t('gapOntheVersion')} : </span>
          <span>{currencySign(guaranteedPrice.gapVersion)}</span>
        </div>
      </div>
    </div>
  );
};
export default CounterAppraisalWhenPriceModified;
CounterAppraisalWhenPriceModified.propTypes = {
  recordId: PropTypes.string.isRequired,
};
